<template>
  <!-- <el-col :span="24"> -->
  <div ref="titleRightContent">
    <v-top-title v-if="title" :title="title" :display="display">
      <slot name="title-right-content" />
    </v-top-title>
    <v-top-title
      v-else-if="titleList && titleList.length > 0"
      :title-list="titleList"
      :display="3"
    />
  </div>
  <el-row class="type-content">
    <!-- 列表 -->
    <div>
      <slot name="title-left-list" />
    </div>

    <!-- 表格 -->
    <div v-if="!type" class="type-rigth" :class="'type' + classType">
      <div ref="search" class="type-search">
        <!--查询条件-->
        <slot name="search-condition-left" />
        <!--查询按钮-->
        <el-button size="default" type="primary" @click="query">查询</el-button>
        <!-- 重置按钮- -->
        <el-button size="default" class="el-button-minor" @click="reset">
          重置
        </el-button>
        <slot name="search-condition-rigth" />
      </div>
      <div class="type-table">
        <slot name="table" />
      </div>
    </div>

    <!-- 自定义 -->
    <div v-else class="custom-box">
      <slot name="title-right-list" />
    </div>
  </el-row>
  <!-- </el-col> -->
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
defineProps<{
  title?: string;
  titleList?: [];
  type: number;
  classType: number;
  display: number;
}>();

const emits = defineEmits<{
  (e: "query"): void;
  (e: "reset"): void;
}>();

const titleRightContent = ref();
const search = ref();
const searchHeight = ref();

onMounted(() => {
  // console.log(111);
  // nextTick(() => {
  //   searchHeight.value = search.value.offsetHeight || 0;
  // });
});

const query = () => {
  emits("query");
};

const reset = () => {
  emits("reset");
};
</script>
<style scoped lang="scss">
.type-content {
  height: calc(100% - 109px);
  display: flex;
  flex-wrap: nowrap;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}

.type-rigth {
  width: 0;
  padding-right: 8px;
  box-sizing: border-box;
  flex: 1;
  position: relative;
  .type-search {
    width: 100%;
    padding-bottom: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    :deep(.el-col),
    :deep(.el-button) {
      margin-left: 15px;
    }
    :deep(.el-button-group > .el-button:last-child) {
      margin: 0 !important;
    }
    :deep(.el-button-group) {
      display: flex;
    }
  }
  .type-table {
    width: 100%;
    height: calc(100% - 52px);
  }
}

.custom-box,
.type2 {
  flex: 1;
  border-radius: 6px;
  margin-left: 10px;
  background-color: #fff;
  border: 8px solid #f2f6fb;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.type2 {
  width: 0;
  overflow: hidden;
  
}

.custom-box::before,
.type2::before {
  content: "";
  position: absolute;
  z-index: 999;
  top: 25px;
  left: -16px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 10px 0;
  border-color: transparent #f5f7fb transparent transparent;
}
</style>
